import React, { useState, useEffect } from "react";
import ReactPaginate from "react-paginate";
import { Modal, Button, Table, Form } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { Link } from "react-router-dom";
import {
  formatDateENGB,
  handleConsoleError,
} from "../../../utils/common-methods";

import { routes } from "../../../constants/routes";
import {
  updateDocumentType,
  addDocumentType,
  getDocumentTypeById,
  getDocumentTypeList,
} from "../../../services/DocumentTypeService";
import { toast } from "react-toastify";

const DocumentTypeMaster = () => {
  // const [documentTypes, setDocumentTypes] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [currentDocumentType, setCurrentDocumentType] = useState(null);

  const [isactive, setIsActive] = useState(false);
  const [currentPage, setCurrentPage] = useState(0);
  const [filteredData, setFilteredData] = useState([]);
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();

  useEffect(() => {
    fetchDocumentTypes();
  }, []);

  const rowsPerPage = 10; // Number of rows to display per page
  const offset = currentPage * rowsPerPage; // Calculate the offset based on current page
  const paginatedData = filteredData.slice(offset, offset + rowsPerPage);

  const fetchDocumentTypes = async () => {
    try {
      const response = await getDocumentTypeList();
      if (response?.isSuccess && response?.data?.length > 0) {
        setFilteredData(response?.data);
        // toast.success(response?.Result.message);
      } else {
        toast.error(response?.message);
      }
    } catch (error) {
      const message = handleConsoleError(error);
      toast.error(error?.message || message);
    }
  };

  const handleShowModal = (documentType = null) => {
    setCurrentDocumentType(documentType);
    reset(documentType || { documentName: "", type: "" });
    setIsActive(documentType?.isActive || false);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setCurrentDocumentType(null);
    reset({ documentName: "", type: "" });
  };

  const onSubmit = async (data) => {
    try {
      if (currentDocumentType) {
        const response = await updateDocumentType(data);
        if (response?.isSuccess) {
          toast.success(response?.message);
        } else {
          toast.error(response?.message);
        }
      } else {
        const response = await addDocumentType(data);
        if (response?.isSuccess) {
          toast.success(response?.message);
        } else {
          toast.error(response?.message);
        }
      }
      fetchDocumentTypes();
      handleCloseModal();
    } catch (error) {
      const message = handleConsoleError(error);
      toast.error(error?.message || message);
    }
  };
  const handleIsActive = (e) => {
    setIsActive(e.target.checked);
  };

  const calculateSNo = (index) => {
    return offset + index + 1;
  };

  const handlePageChange = ({ selected }) => {
    setCurrentPage(selected);
  };
  const renderPagination = () => {
    const pageCount = Math.ceil(filteredData.length / rowsPerPage);
    if (pageCount > 1) {
      return (
        <ReactPaginate
          previousLabel="previous"
          nextLabel="next"
          breakClassName={"page-item"}
          breakLinkClassName={"page-link"}
          containerClassName={"pagination"}
          pageClassName={"page-item"}
          pageLinkClassName={"page-link"}
          previousClassName={"page-item"}
          previousLinkClassName={"page-link"}
          nextClassName={"page-item"}
          nextLinkClassName={"page-link"}
          activeClassName={"active"}
          pageCount={pageCount}
          pageRangeDisplayed={2}
          marginPagesDisplayed={1}
          onPageChange={handlePageChange}
          forcePage={currentPage}
          breakLabel="..."
          disableInitialCallback={false}
        />
      );
    }
    return null;
  };

  return (
    <React.Fragment>
      <Modal show={showModal} onHide={handleCloseModal}>
        <Modal.Header closeButton>
          <Modal.Title>
            {currentDocumentType ? "Edit Document Type" : "Add Document Type"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form onSubmit={handleSubmit(onSubmit)}>
            <Form.Group className="mb-3" controlId="formDocumentName">
              <Form.Label>
                Document Name <span className="text-danger">*</span>
              </Form.Label>
              <Form.Control
                type="text"
                {...register("documentName", {
                  required: "Document Name is required",
                })}
              />
              {errors.documentName && (
                <span className="text-danger">
                  {errors.documentName?.message}
                </span>
              )}
            </Form.Group>

            <Form.Group className="mb-3" controlId="formType">
              <Form.Label>
                Description <span className="text-danger">*</span>
              </Form.Label>
              <Form.Control
                type="text"
                {...register("description", {
                  required: "Description is required",
                })}
              />
              {errors.description && (
                <span className="text-danger">
                  {errors.description?.message}
                </span>
              )}
            </Form.Group>
            <Form.Group className="mb-3" controlId="formIsActive">
              <Form.Group className="mb-3" controlId="formIsActive">
                <div className="custom-check">
                  <label>Status</label>
                  <input
                    type="checkbox"
                    {...register("isActive")}
                    checked={isactive} // Use the local state to control the checkbox
                    onChange={handleIsActive} // Handle changes to the checkbox
                  />
                </div>
              </Form.Group>
              {errors.isActive && (
                <span className="text-danger">{errors.isActive?.message}</span>
              )}
            </Form.Group>
            <Modal.Footer>
              <Button variant="secondary" onClick={handleCloseModal}>
                Close
              </Button>
              <Button variant="primary" type="submit">
                {currentDocumentType ? "Update" : "Save"}
              </Button>
            </Modal.Footer>
          </form>
        </Modal.Body>
      </Modal>

      <div className="pagetitle">
        <nav>
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <Link to={routes.ADMIN_DASHBOARD}>Dashboard</Link>
            </li>
            {/* <li className="breadcrumb-item">Content Management</li>*/}
            <li className="breadcrumb-item active">
              <i className="fa-solid fa-chevron-right"></i> Document Type Master
            </li>
          </ol>
        </nav>
      </div>
      <div className="verifier-buttton">
        <Button variant="primary" onClick={() => handleShowModal()}>
          Add Document Type
        </Button>
      </div>
      <div className="table-responsive">
        <div>
          <h2>Document Type</h2>
        </div>
        <Table striped bordered hover className="mt-3">
          <thead>
            <tr>
              <th>#</th>
              <th>Document Name</th>
              <th>Description</th>
              <th>Created On</th>
              <th>Status</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {/* {documentTypes.map((type, index) => ( */}
            {paginatedData && paginatedData.length > 0 ? (
              <React.Fragment>
                {paginatedData.map((type, idx) => {
                  return (
                    <tr key={idx}>
                      <td>{calculateSNo(idx)}</td>
                      <td>{type?.documentName}</td>
                      <td>{type?.description}</td>
                      <td>{formatDateENGB(type?.createdOn)}</td>
                      <td>
                        <div className="delete-create">
                          {" "}
                          {type?.isActive === true ? (
                            <i className="ri-check-fill"></i>
                          ) : (
                            <i className="ri-close-circle-line"></i>
                          )}
                        </div>
                      </td>
                      <td>
                        <div className="delete-create">
                          <Link onClick={() => handleShowModal(type)}>
                            <i className="ri-pencil-line"></i>
                          </Link>
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </React.Fragment>
            ) : (
              <tr>
                <td colSpan="10 mt-2">No results found</td>
              </tr>
            )}
            {/* ))} */}
          </tbody>
        </Table>
      </div>
      <div className="table-footer">
        <p className="mb-3">
          <strong>Total Count: {filteredData.length}</strong>
        </p>
        {filteredData.length === 0 ? "" : renderPagination()}
      </div>
    </React.Fragment>
  );
};

export default DocumentTypeMaster;
